<template>
  <div class="cookie-box" v-if="host">
    <h2>Сайт {{ host }} использует куки (Cookie).</h2>
    <p v-html="policy?.text" @click.prevent="link"></p>
    <button type="button" @click="accept">Согласен</button>
  </div>
</template>

<script setup>
import { loadScripts } from "~/helpers/file";
const props = defineProps(["js", "policy", "value"]);
const value = props.value + "";
const host = ref();
const accept = () => {
  loadScripts(props.js);
  document.cookie = `cookieAccept=${
    props.policy?.version
  }-${Date.now()}; path=/; secure; max-age=${3600 * 24 * 7 * 56}`;
  host.value = false;
};
const link = ($event) => {
  if (!$event.target.href) return;
  navigateTo(new URL($event.target.href).pathname);
};
onMounted(() => {
  if (value?.startsWith(props.policy?.version)) return loadScripts(props.js);
  host.value = window.location.hostname;
});
</script>
